import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Text from "../atoms/Text";
import Icon from "../atoms/Icon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import cart from "../../assets/cartNormal.png";
import cartHover from "../../assets/cartHover.png";
import addToWishlistIcon from "../../assets/addToWishlist.png";
import blackHeart from "../../assets/blackHeart.png";
import socialMedias from "../../assets/Social Medias.png";
import Button from "../atoms/Button";
import { useUser } from "../../context/UserContext";

export default function ProductCard({ product, size, extraStyling }) {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [isDiscounted, setIsDiscounted] = useState(false);
  const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);
  const [quickViewQuantity, setQuickViewQuantity] = useState(1);
  const { addToCart, toggleWishlist, isInWishlist, replaceCart, currentUser } = useUser();

  const formatPrice = (value) => Number(value).toFixed(2);
  const renderStars = (rating, iconSize, gap) => (
    <div
      style={{
        marginTop: "13px",
        position: "relative",
        display: "inline-block",
        lineHeight: 1,
      }}
    >
      <div
        style={{
          display: "inline-flex",
          gap,
          color: "var(--gray2)",
          fontSize: iconSize,
          lineHeight: 1,
        }}
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <FontAwesomeIcon key={`empty-${index}`} icon={faStar} />
        ))}
      </div>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: `${(rating / 5) * 100}%`,
          overflow: "hidden",
          whiteSpace: "nowrap",
          lineHeight: 1,
        }}
      >
        <div
          style={{
            display: "inline-flex",
            gap,
            color: "var(--warning)",
            fontSize: iconSize,
            lineHeight: 1,
          }}
        >
          {Array.from({ length: 5 }).map((_, index) => (
            <FontAwesomeIcon key={`filled-${index}`} icon={faStar} />
          ))}
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    if (product) {
      setIsDiscounted(product.hasDiscount);
    }
  }, [product]);

  if (!product) return null;

  const isWishlisted = isInWishlist(product.id);

  function goToProductPage() {
    navigate(`/product/${product.id}`);
  }

  function handleCardClick(event) {
    if (event.defaultPrevented || event.target.closest("button")) {
      return;
    }

    event.preventDefault();
    goToProductPage();
  }

  function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function openQuickView(event) {
    stopEvent(event);
    setQuickViewQuantity(1);
    setIsQuickViewOpen(true);
  }

  function closeQuickView() {
    setIsQuickViewOpen(false);
  }

  async function handleQuickViewAddToCart() {
    const existingCart = currentUser?.cart || [];
    const existingItem = existingCart.find((item) => item.productId === product.id);
    const updatedCart = existingItem
      ? existingCart.map((item) =>
          item.productId === product.id
            ? { ...item, quantity: item.quantity + quickViewQuantity }
            : item,
        )
      : [...existingCart, { productId: product.id, quantity: quickViewQuantity }];

    await replaceCart(updatedCart);
    closeQuickView();
  }

  function renderQuickViewModal() {
    if (!isQuickViewOpen) {
      return null;
    }

    return (
      <div
        onClick={closeQuickView}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.55)",
          zIndex: 1100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          boxSizing: "border-box",
        }}
      >
        <div
          onClick={(event) => event.stopPropagation()}
          style={{
            width: "min(1320px, 100%)",
            backgroundColor: "var(--white)",
            borderRadius: "10px",
            padding: "28px 32px 30px",
            position: "relative",
            display: "grid",
            gridTemplateColumns: "1.05fr 1fr",
            gap: "42px",
            alignItems: "start",
          }}
        >
          <button
            type="button"
            onClick={closeQuickView}
            style={{
              position: "absolute",
              top: "16px",
              right: "18px",
              border: "none",
              backgroundColor: "transparent",
              color: "var(--gray7)",
              fontSize: "26px",
              lineHeight: 1,
              cursor: "pointer",
              padding: 0,
            }}
          >
            x
          </button>

          <div
            style={{
              minHeight: "520px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={product.image}
              alt={product.name}
              style={{ width: "100%", maxWidth: "620px", height: "auto", objectFit: "contain" }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "start" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
              <Text size="px40" weight="w600" color="gray9">
                {product.name}
              </Text>
              <span
                style={{
                  padding: "4px 10px",
                  borderRadius: "4px",
                  backgroundColor: "#EAF7E9",
                  color: "var(--primary)",
                  fontSize: "14px",
                  fontWeight: 400,
                }}
              >
                In Stock
              </span>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
              <div style={{ display: "inline-flex", gap: "4px", color: "var(--warning)" }}>
                {Array.from({ length: 5 }).map((_, index) => (
                  <FontAwesomeIcon key={`quick-${index}`} icon={faStar} />
                ))}
              </div>
              <Text size="px14" weight="w400" color="gray5">
                4 Review
              </Text>
              <Text size="px14" weight="w400" color="gray4">
                SKU: 2J15194
              </Text>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
              {product.hasDiscount ? (
                <>
                  <Text
                    size="px20"
                    weight="w400"
                    color="gray4"
                    extraStyles={{ textDecoration: "line-through" }}
                  >
                    ${formatPrice(product.originalPrice)}
                  </Text>
                  <Text size="px32" weight="w600" color="primary">
                    <span style={{ color: "var(--hard-primary)" }}>
                      ${formatPrice(product.price)}
                    </span>
                  </Text>
                  <span
                    style={{
                      padding: "3px 10px",
                      borderRadius: "30px",
                      backgroundColor: "#FDEDED",
                      color: "#EA4B48",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% Off
                  </span>
                </>
              ) : (
                <Text size="px32" weight="w600" color="primary">
                  <span style={{ color: "var(--hard-primary)" }}>
                    ${formatPrice(product.price)}
                  </span>
                </Text>
              )}
            </div>

            <div
              style={{
                width: "100%",
                padding: "24px 0",
                borderTop: "1px solid var(--gray1)",
                borderBottom: "1px solid var(--gray1)",
                display: "flex",
                flexDirection: "column",
                gap: "18px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "16px", width: "100%" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <Text size="px14" weight="w400" color="gray5">
                    Brand:
                  </Text>
                  <div
                    style={{
                      width: "56px",
                      height: "56px",
                      border: "1px solid var(--gray1)",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "var(--primary)",
                      fontSize: "12px",
                      fontWeight: 600,
                    }}
                  >
                    shopery
                  </div>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <Text size="px14" weight="w400" color="gray5">
                    Share item:
                  </Text>
                  <img
                    src={socialMedias}
                    alt="Social media"
                    style={{ width: "184px", height: "40px", objectFit: "contain" }}
                  />
                </div>
              </div>

              <Text
                size="px14"
                weight="w400"
                color="gray5"
                extraStyles={{ lineHeight: "170%", textAlign: "start" }}
              >
                Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla nibh diam, blandit vel consequat nec, ultrices et ipsum. Nulla varius magna a consequat pulvinar.
              </Text>
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                paddingBottom: "20px",
                borderBottom: "1px solid var(--gray1)",
              }}
            >
              <div
                style={{
                  width: "140px",
                  height: "50px",
                  border: "1px solid var(--gray1)",
                  borderRadius: "999px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "0 8px",
                }}
              >
                <button
                  type="button"
                  onClick={() => setQuickViewQuantity((current) => Math.max(1, current - 1))}
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    border: "none",
                    backgroundColor: "var(--gray05)",
                    color: "var(--gray5)",
                    fontSize: "22px",
                    cursor: "pointer",
                  }}
                >
                  -
                </button>
                <Text size="px18" weight="w500" color="gray9">
                  {quickViewQuantity}
                </Text>
                <button
                  type="button"
                  onClick={() => setQuickViewQuantity((current) => current + 1)}
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    border: "none",
                    backgroundColor: "var(--gray05)",
                    color: "var(--gray5)",
                    fontSize: "22px",
                    cursor: "pointer",
                  }}
                >
                  +
                </button>
              </div>

              <Button
                size="large"
                variant="fill"
                onClick={handleQuickViewAddToCart}
                style={{ flex: 1, justifyContent: "center" }}
              >
                Add to Cart
              </Button>

              <button
                type="button"
                onClick={() => toggleWishlist(product)}
                style={{
                  width: "52px",
                  height: "52px",
                  borderRadius: "50%",
                  border: "1px solid var(--gray1)",
                  backgroundColor: isWishlisted ? "#EAF7E9" : "var(--white)",
                  color: isWishlisted ? "var(--primary)" : "var(--gray7)",
                  cursor: "pointer",
                  fontSize: "22px",
                }}
              >
                {isWishlisted ? "?" : "?"}
              </button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "start" }}>
              <Text size="px14" weight="w400" color="gray7">
                <span style={{ fontWeight: 600, color: "var(--gray9)" }}>Category:</span> Vegetables
              </Text>
              <Text size="px14" weight="w400" color="gray7">
                <span style={{ fontWeight: 600, color: "var(--gray9)" }}>Tag:</span> Vegetables Healthy Chinese Cabbage Green Cabbage
              </Text>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderCard(cardWidth, cardHeight, imageWidth, imageHeight, cartSize, textSize, priceSize, starSize, starGap, hoverTop, hoverRight) {
    return (
      <>
        {renderQuickViewModal()}
        <div
          className="productCard"
          onClick={handleCardClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: cardWidth,
            ...extraStyling,
            height: cardHeight,
            position: "relative",
            backgroundColor: "white",
            cursor: "pointer",
            border: isHovered
              ? "1px solid var(--hard-primary)"
              : "1px solid var(--gray1)",
          }}
        >
          <Icon
            src={product.image}
            alt={product.name}
            style={{ width: imageWidth, height: imageHeight }}
          />
          <div
            className="productInfo"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: size === "large" ? "290px" : "240px",
              margin: size === "large" ? "16px 20px 24px 20px" : "12px",
            }}
          >
            <div
              className="productText"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <Text size={textSize} weight="w400" color="greenG7">
                {product.name}
              </Text>
              <div style={{ display: "flex", alignItems: "center" }}>
                {product.hasDiscount ? (
                  <Text
                    size={priceSize}
                    weight="w500"
                    color="greenG9"
                    extraStyles={{
                      lineHeight: "150%",
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                    }}
                  >
                    ${formatPrice(product.price)}
                    <Text
                      size={size === "large" ? "px14" : "px16"}
                      weight="w400"
                      color="greenG4"
                      extraStyles={{ textDecoration: "line-through" }}
                    >
                      ${formatPrice(product.originalPrice)}
                    </Text>
                  </Text>
                ) : (
                  <Text
                    size={priceSize}
                    weight="w500"
                    color="greenG9"
                    extraStyles={{ lineHeight: "150%" }}
                  >
                    ${formatPrice(product.price)}
                  </Text>
                )}
              </div>
              {renderStars(product.rating, starSize, starGap)}
              {isDiscounted ? (
                <Text
                  size="px14"
                  weight="w400"
                  color="white"
                  extraStyles={{
                    backgroundColor: "var(--danger)",
                    padding: "3px 8px",
                    borderRadius: "4px",
                    width: "fit-content",
                    position: "absolute",
                    top: "20px",
                    left: "20px",
                  }}
                >
                  Sale {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}%
                </Text>
              ) : null}
            </div>
            <button
              type="button"
              onClick={(event) => {
                stopEvent(event);
                addToCart(product);
              }}
              style={{
                border: "none",
                backgroundColor: "transparent",
                padding: 0,
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                src={isHovered ? cartHover : cart}
                alt="Add to Cart"
                size={cartSize}
                style={{ cursor: "pointer" }}
              />
            </button>
          </div>
          {isHovered ? (
            <div
              className="hoverButtons"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                position: "absolute",
                top: hoverTop,
                right: hoverRight,
              }}
            >
              <button
                type="button"
                onClick={(event) => {
                  stopEvent(event);
                  toggleWishlist(product);
                }}
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  padding: 0,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  src={isWishlisted ? blackHeart : addToWishlistIcon}
                  size="width: 48px; height: 48px"
                  style={{
                    cursor: "pointer",
                    width: "48px",
                    height: "48px",
                  }}
                />
              </button>
              <button
                type="button"
                onClick={openQuickView}
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  padding: 0,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  src={require("../../assets/quickView.png")}
                  size="width: 48px; height: 48px"
                  style={{ cursor: "pointer" }}
                />
              </button>
            </div>
          ) : null}
        </div>
      </>
    );
  }

  if (size === "large") {
    return renderCard(
      "330px",
      "428px",
      "320px",
      "300px",
      "width: 18px; height: 18px;",
      "px16",
      "px18",
      "14px",
      "3.7px",
      "20px",
      "20px",
    );
  }

  if (size === "medium") {
    return renderCard(
      "264px",
      "327px",
      "254px",
      "230px",
      "width: 15px; height: 15px;",
      "px14",
      "px16",
      "12px",
      "1.7px",
      "16px",
      "16px",
    );
  }

  return null;
}
